hmi.models.transform = function () {
    "use strict";

    //============================================================
    // Public Variables with Default Settings
    //------------------------------------------------------------
    var x,
        y,
        width,
        height;


    //============================================================
    // Private Variables
    //------------------------------------------------------------

    var allData = [],
        type = hmi.constant.SINK,
        selectTargetId,
        dragBehavior,
        dragTarget,
        dispatch = d3.dispatch('componentChange');

    var createDragBehavior = function () {
        dragBehavior = d3.behavior.drag()
            .on('dragstart', function (d, i) {
                console.log('mousedown');
                if (dragTarget) {
                    dragTarget.parentNode.appendChild(dragTarget);
                    d3.select(dragTarget).attr("pointer-events", "none");
                }
            })
            .on('drag', function (d, i) {
                console.log('drag');
                if (dragTarget) {
                    var eventX = hmi.utils.calculateDragEventX(d3.event, availableWidth);
                    var eventY = hmi.utils.calculateDragEventY(d3.event, availableHeight);
                    d3.select(dragTarget)
                        .attr('transform', function (d) {
                            return 'translate(' + 0 + ',' + 0 + ')';
                        });
                    d3.select(dragTarget)
                        .attr('transform', function (d) {
                            return 'translate(' + eventX + ',' + eventY + ')';
                        });
                    var textId = 'tv_' + d3.select(dragTarget).attr('id')
                    d3.select('text#' + textId)
                        .attr('x', eventX)
                        .attr('y', eventY + 45);
                    var textId = 'ta_' + d3.select(dragTarget).attr('id')
                    d3.select('text#' + textId)
                        .attr('x', eventX)
                        .attr('y', eventY - 10);
                }

            })
            .on('dragend', function (d, i) {
                console.log('mouseup');
                if (dragTarget) {
                    var eventX = hmi.utils.calculateDragEventX(d3.event, availableWidth);
                    var eventY = hmi.utils.calculateDragEventY(d3.event, availableHeight);
                    d3.select(dragTarget).attr("pointer-events", "all")
                        .style('stroke', function (d) {
                            return checkAlarm(d) ? '#400000' : '#404040';
                        });
                    var component = null;
                    var componentIndex = allData.findIndex(function (element) {
                        return element.component.id === selectTargetId;
                    });
                    if (componentIndex !== -1) {
                        var textId = 'tv_' + d3.select(dragTarget).attr('id');
                        component = allData[componentIndex];
                        component.component.x = Number(d3.select('text#' + textId).attr('x'));
                        component.component.y = Number(d3.select('text#' + textId).attr('y')) - 45;
                    }
                    dragTarget = null;
                    selectTargetId = null;
                    if (component) {
                        dispatch.componentChange({
                            index: componentIndex,
                            component: component
                        });
                    }

                }
            });
    };

    function transform(selection) {
        selection.each(function (data) {
            allData = data;
            var container = d3.select(this).data(data);
            //var data = selData;
            // Display noData message if there's nothing to show.
            if (!data || !data.length || !data[0].key) {
                return transform;
            }

            transform.container = this;
            if (!dragBehavior) {
                createDragBehavior();
            }
            // Setup containers and skeleton of chart

            //todo resolve with .exit().remove() mechanism now not work
            //clean old component remove duplicate object
            d3.selectAll("g.nv-group-transform > *").remove();

            var wrap = container.selectAll('g.nv-group-transform').data([data]);
            wrap.enter().append('g').attr('class', 'nv-group-transform');
            var gEnter = wrap.selectAll('g.nv-transform').data(data);
            var gComponent = gEnter.enter().append('g')
                .attr('class', 'nv-transform').attr('id', function (d) {
                    return d.id;
                })
                .call(dragBehavior);

            var path = gComponent.append('path')
                .attr('id', function (d) {
                    return d.component.id
                })
                .attr('d', function (d) {
                    return 'M64.5,68.5h-60v-60h60V68.5z M69.5,58.5h-15v15h15V58.5z M34.5,2.5C30.357,2.5,27,5.858,27,10s3.357,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5S38.642,2.5,34.5,2.5z';
                })
                .attr('transform', function (d) {
                    return 'translate(' + d.component.x + ',' + d.component.y + ')';
                });

            transform.update = function () {
                container.call(transform);
            };

        });

        return transform;
    }

    transform.dispatch = dispatch;

    transform.options = hmi.utils.optionsFunc.bind(transform);

    transform._calls = new function () {
        this.getPendingObject = function (data) {
            return {
                type: type,
                link: {
                    linkT: null,
                    linkR: null,
                    linkB: null,
                    linkL: null
                },
                data: data
            };
        };
    };

    transform._options = Object.create({}, {
        // simple options, just get/set the necessary values
        designMode: {
            get: function () {
                return designMode;
            },
            set: function (_) {
                designMode = _;
            }
        },
        availableWidth: {
            get: function () {
                return availableWidth;
            },
            set: function (_) {
                availableWidth = _;
            }
        },
        availableHeight: {
            get: function () {
                return availableHeight;
            },
            set: function (_) {
                availableHeight = _;
            }
        }
    });

    hmi.utils.initOptions(transform);

    return transform;
};